module.exports = __webpack_public_path__ + "static/img/get-point-icon.28492f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/get-point-icon.png
// module id = 1ftj
// module chunks = 0